import { post, get } from '@web3/base-utils';
import { WalletBase, PointsType, BaseRes } from '../types';

/* --------------User Reward Status------------------ */
export enum LotteryFlag {
  NotEnoughStock = 0,
  Calculating = 1,
  AbleToClaim = 2,
}

export type SingleReward = {
  rewardAmount: string;
  rewardToken: string;
  tokenIcon: string;
};

export type UserRewardStatus = {
  usedLotteryTimes: number;
  remainingLotteryTimes: number;
  totalLotteryTimes: number;
  lotteryFlag: LotteryFlag;
  rewards: SingleReward[];
};

export const getUserRewardStatus = (
  wallet: WalletBase
): Promise<BaseRes<UserRewardStatus | null>> => {
  return get<UserRewardStatus | null>(
    '/web3/api/point/v2/lottery/reward/detail',
    wallet
  );
};

/* --------------User Points History------------------ */
export type SinglePointsHistory = {
  point: number;
  time: string;
  type: PointsType;
  title: string;
  id: number;
};

export const getPointsHistory = (params: WalletBase) => {
  return get<SinglePointsHistory[]>(
    `/web3/api/point/v2/wallet/point/history`,
    params
  );
};

/* --------------Draw a Lottery------------------ */
export enum LotteryType {
  Single = 0,
  TenTimes = 1,
}

export type SingleDrawLotteryStatus = {
  rewardToken: string;
  amount: string;
  tokenIcon: string;
};

export type DrawLotteryStatus = {
  remainingLotteryTimes: number;
  rewards: SingleDrawLotteryStatus[];
};

export const drawLottery = (
  wallet: WalletBase,
  lotteryType: LotteryType
): Promise<BaseRes<DrawLotteryStatus>> => {
  return post('/web3/api/point/v2/lottery/open', {
    walletId: wallet.walletId,
    walletType: wallet.walletType,
    lotteryType,
  });
};

/* --------------Lottery Rules------------------ */
export type SingleLotteryRule = {
  rewardAmount: string;
  rewardToken: string;
};

export const getLotteryRules = (): Promise<BaseRes<SingleLotteryRule[]>> => {
  return get<SingleLotteryRule[]>('/web3/api/point/v1/lottery/reward/list');
};
